/* eslint-disable import/prefer-default-export */
import { InsightViewOptionStrings } from 'enums/InsightViewOption'

export const isConvergedMedia = (viewOption: InsightViewOptionStrings) =>
  viewOption === 'OWNED_PARTNERED_EARNED'
